type Props = {
	id: string;
	width?: string;
	height?: string;
	cssClass?: string;
	ariaHidden?: boolean;
};

export default function Icon({
	id,
	width = '1em',
	height = '1em',
	cssClass = '',
	ariaHidden = true,
}: Props) {
	return (
		<svg
			className={cssClass}
			width={width}
			height={height}
			aria-hidden={ariaHidden}
		>
			<use
				href={`/wp-content/plugins/cybersicherheit-features/img/partner-icons.svg#${id}`}
			/>
		</svg>
	);
}
